(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('sidebar', Sidebar)

    /** @ngInject */
    function Sidebar($rootScope, $window, $timeout, $state, AuthenticationService, HelperService, PATHS, LOCAL_STORAGE_ITEMS, DATA_EVENTS) {
        function SidebarController($scope) {
            const vm = this;

            vm.getClusterPerformanceCard = () => {
                const clusterPerformance = vm.loggedUserData.ClusterPerformance;

                if (clusterPerformance.Id == 1)
                    return `/app/dist/images/cluster-cards/bronze.png`;
                else if (clusterPerformance.Id == 2)
                    return `/app/dist/images/cluster-cards/silver.png`;
                else if (clusterPerformance.Id == 3)
                    return `/app/dist/images/cluster-cards/gold.png`;
                else if (clusterPerformance.Id == 4)
                    return `/app/dist/images/cluster-cards/diamond.png`;
            }

            vm.toggleMenuOpen = () => {
                vm.menuOpen = !vm.menuOpen;

                $rootScope.menuOpen = vm.menuOpen;

                localStorage.setItem(LOCAL_STORAGE_ITEMS.MENU, vm.menuOpen);
            }

            vm.handleSubmodule = module => {
                if (!module.ParentModuleId) {
                    if (!module.IsOpen) {
                        vm.modules.forEach(mod => {
                            mod.IsOpen = false;
                        });

                        if (module.Module1.length)
                            module.IsOpen = true;
                    } else {
                        module.IsOpen = false;
                    }
                }
            }

            vm.getState = module => {
                if (module.Module1 && module.Module1.length)
                    return 'null';

                let state = $state.get().find(state => (state.url == module.Url));

                return state ? state.name : 'app.home';
            }

            vm.isActiveMenu = module => {
                if (module.ParentModuleId)
                    return module.Url == $state.current.url;

                return module.Id == $state.current.moduleId;
            }

            vm.getPersonImage = () => {
                let personMainImage = vm.loggedUserData.Person_Image.find(image => (image.Main));

                if (personMainImage)
                    return HelperService.imageResizePath('person', vm.loggedUserData.Id, personMainImage.Url, 150, 150);

                return '/api/images/res/100/100/placeholder.jpg';
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                vm.modules = [];

                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function compareMenuTitle(a, b) {
                if (a.Title < b.Title)
                    return -1;

                if (a.Title > b.Title)
                    return 1;

                return 0;
            }

            function setFirstRunCurrentModule() {
                let currentStateUrl = $state.current.url;

                if (currentStateUrl.split('/').length > 2) {
                    currentStateUrl = `/${currentStateUrl.split('/')[1]}`
                }

                let currentModule = vm.modules.find(mod => (currentStateUrl == mod.Url));

                if (!currentModule) {
                    vm.modules.forEach(mod => {
                        if (mod.Module1 && mod.Module1.length && mod.Module1.find(subMod => subMod.Url == currentStateUrl)) {
                            currentModule = mod;
                        }
                    })
                }

                if (currentModule)
                    currentModule.IsOpen = true;
            }

            function init() {
                vm.logout = AuthenticationService.logout;
                vm.loggedUserData = AuthenticationService.getUserData();
                vm.isMobile = $rootScope.isMobile;

                angular.element($window).on('resize', () => {
                    $rootScope.isMobile = HelperService.isScreenSmaller(767);

                    $timeout(() => {
                        vm.isMobile = $rootScope.isMobile;
                    });
                });

                const lsValue = localStorage.getItem(LOCAL_STORAGE_ITEMS.MENU);
                let isMenuOpen = true;

                if (lsValue == 'false' || lsValue == false || vm.isMobile)
                    isMenuOpen = false;

                $timeout(() => {
                    vm.menuOpen = isMenuOpen;
                    $rootScope.menuOpen = isMenuOpen;

                    $.fn.scrollbar && $('.scrollable').scrollbar({
                        ignoreOverlay: false
                    });

                    const modules = AuthenticationService.getModules().sort(compareMenuTitle);

                    vm.modules = modules;

                    setFirstRunCurrentModule();
                })
            }
        }

        return {
            bindToController: true,
            controller: SidebarController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/sidebar/sidebar.html`,
            scope: {}
        }
    }
}());